import { ThemeService } from './theme.service';

export function themeInitializer(theme: ThemeService): () => void {
  return () => {
    theme.init();
  };
}
